// extracted by mini-css-extract-plugin
module.exports = {"tab_icon":"index_tab_icon_2S8gm","list":"index_list_3hILE","table_title":"index_table_title_1Bd9W","mr4":"index_mr4_1FEwR"};